import React from "react"
import { connect } from "react-redux"
import { isCurrentEpisodeLast, isCurrentEpisodeLocked } from "../../helpers"

import MotionContainer from "../../../design/LastPage/MotionContainer"
import RecommendedEpisodes from "./RecommendedEpisodes"
import RecommendedStories from "./RecommendedStories"
import SocialActions from "./SocialActions"

const t = I18n.t("components.episode_last_page")
const sActions = t.social_actions

const LastPage = ({
  currentEpisode,
  isCurrentEpisodeLast,
  isCurrentEpisodeLocked,
  hasLoadedEpisodes,
  story,
  inIframe = false
}) => (
  <MotionContainer inIframe={inIframe}>
    {isCurrentEpisodeLast ? (
      <RecommendedStories
        currentEpisode={currentEpisode}
        t={t.recommended_stories}
      />
    ) : (
      hasLoadedEpisodes && <RecommendedEpisodes t={t.recommended_episodes} />
    )}

    {!isCurrentEpisodeLocked && (
      <SocialActions
        currentEpisode={currentEpisode}
        story={story}
        like={sActions.like}
        share={sActions.share}
        linkCopied={sActions.link_coppied}
      />
    )}
  </MotionContainer>
)

const mapState = (state) => ({
  currentEpisode: state.currentEpisode,
  hasLoadedEpisodes: state.episodes.length > 0,
  isCurrentEpisodeLast: isCurrentEpisodeLast(state),
  isCurrentEpisodeLocked: isCurrentEpisodeLocked(state),
  story: state.story
})

export default connect(mapState)(LastPage)
